import React from "react";
import { Container, Typography} from "@mui/material";

const TerminosYCondiciones = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>

      {/* Título principal */}
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Términos y condiciones
      </Typography>

      {/* Política de privacidad */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Política de privacidad
      </Typography>

      <Typography variant="body2" paragraph>
        Fustec ("nosotros", "nosotros" o "nuestro") opera el sitio web
        https://rastreo.fustec-seguridad.com./, el software de seguimiento Fustec, la aplicación móvil
        Fustec. Esta página le informa sobre nuestras políticas con respecto a la recopilación, uso y
        divulgación de datos personales cuando utiliza nuestro Servicio y las opciones que ha
        asociado con esos datos.
      </Typography>

      <Typography variant="body2" paragraph>
        Utilizamos sus datos para proporcionar y mejorar el Servicio. Al usar el Servicio, usted
        acepta la recopilación y el uso de información de acuerdo con esta política. A menos que se
        defina lo contrario en esta Política de privacidad, los términos utilizados en esta Política de
        privacidad tienen el mismo significado que en nuestros Términos y condiciones.
      </Typography>

      {/* Recolección */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Recolección de información y uso
      </Typography>

      <Typography variant="body2" paragraph>
        Recopilamos varios tipos diferentes de información con diversos fines para proporcionarle y
        mejorar nuestro Servicio.
      </Typography>

      {/* Tipos de datos */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Tipos de datos recopilados
      </Typography>

      <Typography variant="body2" gutterBottom>
        Información personal
      </Typography>

      <Typography variant="body2" component="div" paragraph>
        - Dirección de correo electrónico<br />
        - Nombre y apellido<br />
        - Cookies y datos de uso<br />
        - Datos de uso
      </Typography>

      <Typography variant="body2" paragraph>
        También podemos recopilar información que su navegador envía cada vez que visita nuestro
        Servicio o cuando accede al Servicio desde un dispositivo móvil (“Datos de uso”).
      </Typography>

      <Typography variant="body2" paragraph>
        Estos Datos de uso pueden incluir información como la dirección del Protocolo de Internet
        de su computadora (por ejemplo, la dirección IP), el tipo de navegador, la versión del
        navegador, las páginas de nuestro Servicio que visita, la hora y la fecha de su visita, el
        tiempo dedicado a esas páginas, único identificadores de dispositivo y otros datos de
        diagnóstico.
        <br /><br />
        Cuando accede al Servicio desde o a través de un dispositivo móvil, estos Datos de uso
        pueden incluir información como el tipo de dispositivo móvil que utiliza, la ID única de su
        dispositivo móvil, la dirección IP de su dispositivo móvil, su sistema operativo móvil, el tipo
        de navegador de Internet móvil que utiliza, identificadores de dispositivo únicos y otros datos
        de diagnóstico.
      </Typography>

      {/* Cookies */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Seguimiento y datos de cookies
      </Typography>

      <Typography variant="body2" paragraph>
        Utilizamos cookies y tecnologías de seguimiento similares para rastrear la actividad en
        nuestro Servicio y mantener cierta información.
        Las cookies son archivos con una pequeña cantidad de datos que pueden incluir un
        identificador único anónimo. Las cookies se envían a su navegador desde un sitio web y se
        almacenan en su dispositivo. Las tecnologías de seguimiento también utilizadas son balizas,
        etiquetas y scripts para recopilar y rastrear información y para mejorar y analizar nuestro
        Servicio.
      </Typography>

      <Typography variant="body2" paragraph>
        Puede indicar a su navegador que rechace todas las cookies o que indique cuándo se envía
        una cookie. Sin embargo, si no acepta las cookies, es posible que no pueda usar algunas
        partes de nuestro Servicio.
      </Typography>

      {/* Ejemplos */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Ejemplos de cookies que utilizamos:
      </Typography>

      <Typography variant="body2" component="div" paragraph>
        - Cookies de sesión Utilizamos cookies de sesión para operar nuestro servicio.<br />
        - Cookies de preferencia. Utilizamos cookies de preferencias para recordar sus
        preferencias y diversas configuraciones.<br />
        - Cookies de seguridad Utilizamos cookies de seguridad con fines de seguridad.<br />
        - Uso de datos<br />
      </Typography>

      {/* Uso de datos */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Fustec utiliza los datos recopilados para diversos fines:
      </Typography>

      <Typography variant="body2" component="div" paragraph>
        - Para proporcionar y mantener el Servicio<br />
        - Para notificarle sobre cambios en nuestro Servicio<br />
        - Para permitirle participar en funciones interactivas de nuestro Servicio cuando elija
        hacerlo<br />
        - Para proporcionar atención al cliente y soporte<br />
        - Proporcionar análisis o información valiosa para que podamos mejorar el Servicio.<br />
        - Para monitorear el uso del Servicio<br />
        - Para detectar, prevenir y abordar problemas técnicos<br />
        - Transferencia de datos<br />
      </Typography>

      <Typography variant="body2" paragraph>
        Su información, incluidos los Datos personales, puede transferirse a computadoras ubicadas
        fuera de su estado, provincia, país u otra jurisdicción gubernamental, y mantenerse en ellas,
        donde las leyes de protección de datos pueden diferir de las de su jurisdicción.
      </Typography>

      <Typography variant="body2" paragraph>
        Su consentimiento a esta Política de privacidad seguido de su envío de dicha información
        representa su aceptación de esa transferencia.
        Fustec tomará todas las medidas razonablemente necesarias para garantizar que sus
        datos se traten de manera segura y de acuerdo con esta Política de privacidad y no se
        realizará ninguna transferencia de sus Datos personales a una organización o país a menos
        que existan controles adecuados, incluida la seguridad de sus datos y otra información
        personal.
      </Typography>

      {/* Divulgación */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Divulgación de datos
      </Typography>

      <Typography variant="body2" paragraph>
        Requerimientos legales
        Fustec puede divulgar sus Datos personales en la creencia de buena fe de que dicha
        acción es necesaria para:<br />
        - Para cumplir con una obligación legal<br />
        - Para proteger y defender los derechos o propiedad de Fustec<br />
        - Para prevenir o investigar posibles irregularidades en relación con el Servicio<br />
        - Para proteger la seguridad personal de los usuarios del Servicio o del público.<br />
        - Para protegerse contra la responsabilidad legal<br />
        - Seguridad de datos<br />
      </Typography>

      <Typography variant="body2" paragraph>
        La seguridad de sus datos es importante para nosotros, pero recuerde que ningún método
        de transmisión por Internet o método de almacenamiento electrónico es 100% seguro. Si
        bien nos esforzamos por utilizar medios comercialmente aceptables para proteger sus
        Datos personales, no podemos garantizar su seguridad absoluta.
      </Typography>

      {/* Proveedores */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Proveedores de servicio
      </Typography>

      <Typography variant="body2" paragraph>
        Podemos emplear a empresas e individuos de terceros para facilitar nuestro Servicio
        ("Proveedores de servicios"), para proporcionar el Servicio en nuestro nombre, para realizar
        servicios relacionados con el Servicio o para ayudarnos a analizar cómo se utiliza nuestro
        Servicio.
      </Typography>

      <Typography variant="body2" paragraph>
        Estos terceros tienen acceso a sus Datos personales solo para realizar estas tareas en
        nuestro nombre y están obligados a no divulgarlos ni usarlos para ningún otro propósito.
      </Typography>

      {/* Analítica */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Analítica
      </Typography>

      <Typography variant="body2" paragraph>
        Podemos utilizar proveedores de servicios externos para monitorear y analizar el uso de
        nuestro servicio.
        Google Analytics es un servicio de análisis web ofrecido por Google que rastrea e informa el
        tráfico del sitio web. Google utiliza los datos recopilados para rastrear y controlar el uso de
        nuestro Servicio. Estos datos se comparten con otros servicios de Google. Google puede
        usar los datos recopilados para contextualizar y personalizar los anuncios de su propia red
        publicitaria. Para obtener más información sobre las prácticas de privacidad de Google,
        visite la página web de Privacidad y Términos de Google.
        <br /><br />
        Nuestro servicio puede contener enlaces a otros sitios que no son operados por nosotros. Si
        hace clic en un enlace de un tercero, se lo dirigirá al sitio de ese tercero. Le recomendamos
        encarecidamente que revise la Política de privacidad de cada sitio que visite.
        No tenemos control ni asumimos ninguna responsabilidad por el contenido, las políticas de
        privacidad o las prácticas de sitios o servicios de terceros.
      </Typography>

      {/* Privacidad infantil */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Privacidad infantil
      </Typography>

      <Typography variant="body2" paragraph>
        Nuestro Servicio no se dirige a menores de 18 años ("Niños).
        No recopilamos a sabiendas información de identificación personal de ninguna persona
        menor de 18 años. Si usted es un padre o tutor y sabe que sus hijos nos han proporcionado
        datos personales, contáctenos. Si nos damos cuenta de que hemos recopilado Datos
        personales de niños sin verificación del consentimiento de los padres, tomamos medidas
        para eliminar esa información de nuestros servidores.
      </Typography>

      {/* Cambios */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Cambios a esta política de privacidad
      </Typography>

      <Typography variant="body2" paragraph>
        Podemos actualizar nuestra Política de privacidad de vez en cuando. Le notificaremos
        cualquier cambio publicando la nueva Política de privacidad en esta página.
        Le informaremos por correo electrónico y / o un aviso destacado sobre nuestro Servicio,
        antes de que el cambio entre en vigencia y actualizaremos la "fecha de vigencia" en la parte
        superior de esta Política de privacidad.
      </Typography>

      <Typography variant="body2" paragraph>
        Se le recomienda que revise esta Política de privacidad periódicamente para detectar
        cualquier cambio. Los cambios a esta Política de privacidad son efectivos cuando se
        publican en esta página.
      </Typography>

      {/* Contacto */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Contáctenos
      </Typography>

      <Typography variant="body2">
        Si tiene alguna pregunta sobre esta Política de privacidad, contáctenos por correo
        electrónico: comercialfustec@gmail.com
      </Typography>

    </Container>
  );
};

export default TerminosYCondiciones;
